import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'helpers/GlobalHelper';
import CountdownText from 'components/CountdownText';
import classNames from 'classnames';

import Style from './Countdown.module.scss';

const Countdown = ({ background, timeLeft, onCountdownEnd, isMiniPlayerActive }) => {
  const { countdown_title_text: countdownTitleText } = window.Language;
  return (
    <div
      className={classNames([Style.container, isMiniPlayerActive ? Style.miniPlayerActive : null])}
    >
      <img className={Style.background} src={background} alt="" />
      <div className={Style.messageContainer}>
        <h3>{countdownTitleText}</h3>
        <h4>
          <CountdownText duration={timeLeft} onCountdownEnd={onCountdownEnd} isVideoContainer />
        </h4>
      </div>
    </div>
  );
};

Countdown.propTypes = {
  background: PropTypes.string,
  isMiniPlayerActive: PropTypes.bool,
  onCountdownEnd: PropTypes.func,
  timeLeft: PropTypes.number,
};

Countdown.defaultProps = {
  background: '',
  isMiniPlayerActive: false,
  timeLeft: '',
  onCountdownEnd: noop,
};

export default Countdown;
